//@flow
import React, { Component } from 'react';
import {
  TransactionFilterDiv,
  ChevronSvg,
  TransactionFilterItemLi,
  FilterOptionSelectedLi,
  InactiveLabelLi
} from './TableFilterStyles';

import { ContentLargeOnlySpan } from './ResponsiveHelpersStyles';
// type Option = { value: string | number, text: string };
type Props = {
  // options: Option[] | string[] | number[],
  options: Array<*>,
  onChange: (value: any) => void,
  value: ?string | number,
  label?: string,
  ignoreActiveStyles?: boolean,
  leftEnd?: boolean,
  rightEnd?: boolean,
  prefix?: string,
  scale?: number,
  disabled?: boolean,
  noMaxWidth?: boolean,
  fixedWidth?: boolean,
  setWidth?: string,
  outline?: boolean
};

type State = {
  open: boolean
};

class TableFilter extends Component<Props, State> {
  state = { open: false };

  closeDropdown = () => {
    this.setState({ open: false });
    window.removeEventListener('click', this.requestClose);
  };

  requestClose = () => {
    this.closeRequest = setTimeout(() => {
      this.closeDropdown();
    }, 25);
  };
  closeRequest: TimeoutID;

  openDropdown = () => {
    this.openTimeout = setTimeout(() => {
      window.addEventListener('click', this.requestClose);
    }, 50);
    this.setState({
      open: !this.state.open
    });
  };
  openTimeout: TimeoutID;

  handleTitleClick = () => {
    if (!this.state.open) {
      this.openDropdown();
    } else {
      this.closeDropdown();
    }
  };
  componentWillUnmount() {
    if (this.openTimeout) {
      clearTimeout(this.openTimeout);
    }
    if (this.closeRequest) {
      clearTimeout(this.closeRequest);
    }
  }

  render() {
    let selectedText = this.props.label;
    for (let i = 0; i < this.props.options.length; i++) {
      const option = this.props.options[i];
      if (['string', 'number'].includes(typeof option)) {
        if (option === this.props.value) {
          selectedText = option;
          break;
        }
      } else if (option.value === this.props.value) {
        selectedText = option.text;
        break;
      }
    }
    const disabled = this.props.options.length === 0 || this.props.disabled;
    const isActive =
      (Boolean(this.props.value) || this.props.value === 0) &&
      !this.props.ignoreActiveStyles;
    const displayLabelAsOption =
      this.props.label && this.state.open && selectedText !== this.props.label;
    return (
      <TransactionFilterDiv
        isActive={isActive}
        open={this.state.open}
        onClick={disabled ? undefined : this.handleTitleClick}
        leftEnd={this.props.leftEnd}
        rightEnd={this.props.rightEnd}
        scale={this.props.scale}
        disabled={disabled}
        noMaxWidth={this.props.noMaxWidth}
        fixedWidth={this.props.fixedWidth}
        setWidth={this.props.setWidth}
        outline={this.props.outline}
      >
        <ul style={{ width: '100%' }}>
          <FilterOptionSelectedLi isActive={isActive} disabled={disabled}>
            <span>
              <ContentLargeOnlySpan>{this.props.prefix}</ContentLargeOnlySpan>
              {selectedText}
            </span>
            <ChevronSvg />
          </FilterOptionSelectedLi>
          {displayLabelAsOption && (
            <InactiveLabelLi
              onClick={() => this.props.onChange(undefined)}
              hideBorder={this.props.options.length === 1}
            >
              {this.props.label}
            </InactiveLabelLi>
          )}
          {this.state.open &&
            this.props.options.map(item => {
              let text;
              let value;
              if (['string', 'number'].includes(typeof item)) {
                text = value = item;
              } else if (item instanceof Object) {
                text = item.text;
                value = item.value;
              }
              if (value === this.props.value) {
                return null;
              }
              return (
                <TransactionFilterItemLi
                  key={value}
                  // style={{ paddingTop: 16 }}
                  onClick={() => this.props.onChange(value)}
                  selected={value === this.props.value}
                >
                  {text}
                </TransactionFilterItemLi>
              );
            })}
        </ul>
      </TransactionFilterDiv>
    );
  }
}

export default TableFilter;
